import React, { useState } from 'react';
import classes from './Accordion.module.css'
import { IoAdd, IoRemove } from 'react-icons/io5';

const Accordion = ({ title, content, noBorder }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={classes.wrapper} style={{border: noBorder && "none"}}>
      <div className={classes.title} onClick={toggleAccordion}>
        <h4>{title}</h4>
        <span>{isOpen ? <IoRemove size={23} /> : <IoAdd size={20}/>}</span>
      </div>
      {isOpen && <div className={classes.content}>{content}</div>}
    </div>
  );
};

export default Accordion